module.exports = __webpack_public_path__ + "img/face.8d0a8c82.svg";